import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const IdmeScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {idme} = commerceAPI
    const {config} = idme || {}

    var idmeScriptPath = null
    var idMeCartShow = false

    try {
        const jsonConfig = JSON.parse(config)
        idmeScriptPath = jsonConfig.idMeScriptPath
        idMeCartShow = jsonConfig.idMeCartShow
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (!idmeScriptPath && !idMeCartShow) return

        if (document.querySelector(`script[src="${idmeScriptPath}"]`)) {
            return
        }
        const script = document.createElement('script')
        script.src = idmeScriptPath
        script.async = true
        document.body.appendChild(script)
        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return null
}

export default IdmeScript
